<ng-container *transloco="let t">
  <div class="modal-header">
    <h2>{{ t('childHistory/editDateTitle') }}</h2>
  </div>

  <div class="modal-body">
    <p class="message">{{ t('childHistory/editDateHint', { field: fieldLabel }) }}</p>
    <div class="form-item">
      <label class="form-label" for="history-date-input">{{ t('childHistory/editDateLabel') }}</label>
      <input id="history-date-input" class="form-control" type="date" [formControl]="validFromControl" />
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-lg btn-outline-primary" (click)="activeModal.dismiss()">
      {{ t('childHistory/cancel') }}
    </button>
    <button type="button" class="btn btn-lg btn-primary" (click)="submit()">{{ t('shared/save') }}</button>
  </div>
</ng-container>
